// @ts-nocheck

import moment from 'moment';
import { fetchRequest, initialFetchListParams } from './index';


import {
  convertFromKopToRub,
  convertFromRubToKop } from '../pure/unitConversions';
import { formatDateTimeToString } from '../pure/date';

export const convertDataFromServer = (monitoringPrice) => ({
  ...monitoringPrice,
  amountPayment: convertFromKopToRub(monitoringPrice.amountPayment)
});

export const convertDataToServer = (monitoringPrice) => ({
  ...monitoringPrice,
  amountPayment: convertFromRubToKop(monitoringPrice.amountPayment)
});

export const getMonitoringPriceByPeriod = async (date) => {
  const periods = await fetchRequest.get(
    `/monitoringPrice/${formatDateTimeToString(date, 'YYYY-MM-DD')}/byPeriod`
  );
  if (periods) return convertDataFromServer(periods);
  throw new Error('Не удалось подтянуть прайс по данной дате акта');
};

export const addMonitoringPrice = async (
monitoringPrice) =>
{
  const added = await fetchRequest.post(
    '/monitoringPrice',
    convertDataToServer(monitoringPrice)
  );
  if (added) return convertDataFromServer(added);
  throw new Error('Не удалось добавить прайс для мониторинга');
};

export const fetcMonitoringPrice = async (
params = initialFetchListParams) =>
{
  const monitoringPrices = await fetchRequest.get('/monitoringPrice', {
    ...initialFetchListParams,
    ...params
  });
  if (monitoringPrices)
  return {
    ...monitoringPrices,
    data: monitoringPrices.data.map(convertDataFromServer)
  };
  throw new Error('Не удалось получить список прайсов для мониторинга');
};

export const updateMonitoringPrice = async (
monitoringPrice) =>
{
  const updated = await fetchRequest.put(
    '/monitoringPrice',
    convertDataToServer(monitoringPrice)
  );
  if (updated) return convertDataFromServer(updated);
  throw new Error('Не удалось обновить прайс мониторинга');
};

export const getMonitoringPrice = async (
id) =>
{
  let washingVehicleType = await fetchRequest.get(`/monitoringPrice/${id}`);
  if (washingVehicleType) return convertDataFromServer(washingVehicleType);
  throw new Error('Не удалось загрузить прайс мониторинга');
};

export const deleteMonitoringPrice = async (
id) =>
{
  const deleted = await fetchRequest.delete(`/monitoringPrice/${id}`);
  if (deleted) return convertDataFromServer(deleted);
  throw new Error('Не удалось удалить прайс мониторинга');
};

export default {
  getMonitoringPriceByPeriod,
  addMonitoringPrice,
  fetcMonitoringPrice,
  updateMonitoringPrice,
  getMonitoringPrice,
  deleteMonitoringPrice
};
